const columns = [
  {
    title: 'Template Name',
    dataIndex: 'templateName',
    sorter: true,
  },
  {
    title: 'Email Subject',
    dataIndex: 'subject',
    sorter: true,
  },
  {
    title: 'Created Date',
    dataIndex: 'templateDetailsCreatedDate',
    sorter: true,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
  },
];

export default columns;  